<template>
  <a-modal
    width="1000px"
    :title="modalTitel"
    :visible="visible"
    v-if="visible"
    :confirm-loading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item
        class="form-item"
        label="预约老师"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'tname',
            {
              initialValue: planDetail.english_name
            }
          ]"
          disabled/>
      </a-form-item>
      <a-form-item
        class="form-item"
        label="预约日期"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'days',
            {
              initialValue: planDetail.days
            }
          ]"
          disabled/>
      </a-form-item>
      <a-form-item
        class="form-item"
        label="预约时段"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-input
          v-decorator="[
            'times',
            {
              initialValue: planDetail.times
            }
          ]"
          disabled/>
      </a-form-item>
      <!-- <a-form-item
        class="form-item"
        label="旺旺名"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          show-search
          :not-found-content="fetching ? undefined : null"
          :filter-option="false"
          @search="handleSearchAccount"
          @change="handleUaccountChange"
          v-decorator="[
            'uid',
            {
              rules: [{ required: true, message: '请输入搜索选择旺旺名' }]
            }
          ]"
          placeholder="请输入搜索选择旺旺名">
          <a-spin v-if="fetching" slot="notFoundContent" size="small" />
          <a-select-option v-for="item in userDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item> -->
      <a-form-item
        class="form-item"
        :required="true"
        label="选择订单"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <tcg-table
          ref="table"
          size="default"
          rowKey="order_id"
          :columns="columns"
          :data="loadData"
          bordered
        >
          <span slot="action" slot-scope="text, record">
            <template>
              <a v-if="record.order_id === data.order_id">已选择</a>
              <a v-if="record.order_id !== data.order_id" @click="selectOrders(record)">选择</a>
            </template>
          </span>
        </tcg-table>
      </a-form-item>
      <a-form-item
        class="form-item"
        label="指定教材"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          :allowClear="true"
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          @change="handleMaterialChange"
          v-model="data.mat_id"
          placeholder="请选择教材">
          <a-select-option v-for="item in materialDict" :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        class="form-item"
        label="选择话题"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          mode="multiple"
          v-model="data.topic"
          placeholder="雅思等课程请选择话题，可多选，黄色话题表示已完成">
          <a-select-option v-if="item.pid !== 0" v-for="item in topicDict" :key="item.detail_id" :value="item.detail_id">
            <span :style="item.checked==='YES'?'color:yellow':''">{{ item.pid | valInDict(topicPidDict) }} : {{ item.title }}<span v-if="item.is_new === 'YES'" style="color:Red;">(NEW)</span></span>
          </a-select-option>
        </a-select>
        <!-- <span style="font-size:12px;">提示：黄色话题表示已完成</span> -->
      </a-form-item>
      <a-form-item
        class="form-item"
        label="选择课件"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-select
          show-search
          option-filter-prop="children"
          :filter-option="filterOption"
          v-model="data.ware_id"
          placeholder="日常、商务、面试等课程请选择课件">
          <a-select-option v-for="item in wareDict" :key="item.detail_id" :value="item.detail_id">{{ item.title }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        class="form-item"
        label="上传课件"
        :labelCol="labelCol"
        :wrapperCol="wrapperCol"
      >
        <a-upload
          name="file"
          :multiple="false"
          list-type="text"
          action="/index.php/upload_file/uploadFile?type=studentkj"
          @change="handleKjpahChange"
        >
          <a-button><a-icon type="upload" />点击上传课件</a-button>
          <span style="margin-left:20px;font-size:12px;">提示：选择课件和上传课件二选一，上传课件会覆盖选择课件</span>
        </a-upload>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { getPre, getList, getDictByCourse } from '@/api/orders'
import { searchUser } from '@/api/member'
import { getDetailList } from '@/api/material'
import { yuYue } from '@/api/subscribe'
import { valInDict } from '@/utils/util'
import _ from 'lodash'
import { TcgTable } from '@/components'
export default {
  components: {
    TcgTable
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    planDetail: {
      type: Object,
      default: function () {
        return {}
      }
    },
    ctname: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      // form-item标题样式
      labelCol: { lg: { span: 4 }, sm: { span: 5 } },
      // form-item组件样式
      wrapperCol: { lg: { span: 20 }, sm: { span: 19 } },
      // 抽屉加载
      loading: false,
      viewDetailData: {},
      // 字典
      dict: {},
      userDict: [],
      materialDict: [],
      wareDict: [],
      fetching: false,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        uaccount: '',
        isYuyue: 'YES',
        ctname: ''
      },
      // 表头
      columns: [
        {
          title: 'ID',
          dataIndex: 'order_id'
        },
        {
          title: '课程名称',
          dataIndex: 'cname'
        },
        {
          title: '开始时间',
          dataIndex: 'stime'
        },
        {
          title: '截止时间',
          dataIndex: 'etime'
        },
        {
          title: '可预约',
          dataIndex: 'surplus_num'
        },
        {
          title: '操作',
          dataIndex: 'id',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return getList(Object.assign(parameter, this.queryParam))
          .then(res => {
            return res
          })
      },
      modalTitel: '预约',
      confirmLoading: false,
      form: this.$form.createForm(this),
      data: {
        uid: '',
        uaccount: '',
        order_id: 'ALL',
        ctype: '',
        mat_id: undefined,
        course_id: '',
        ware_id: undefined,
        topic: [],
        tid: this.planDetail.tid,
        days: '',
        times: ''
      },
      topicDict: [],
      topicPidDict: []
    }
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.values = _.get(res, 'values', {})
        }
      })
    },
    handleSearchAccount (value) {
      console.log(value)
      if (value === '') {
        return false
      }
      this.userDict = []
      this.fetching = true
      searchUser({ account: value }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.userDict = _.get(res, 'data', [])
          this.fetching = false
        }
      })
    },
    handleUaccountChange (value) {
      this.data.uid = value
      const uaccount = valInDict(this.data.uid, this.userDict, 'id', 'name', '')
      this.queryParam.uaccount = this.data.uaccount = uaccount
      this.$refs.table.refresh(true)
    },
    selectOrders (record) {
      this.data.mat_id = undefined
      this.materialDict = []
      this.wareDict = []
      this.topicDict = []
      this.data.ware_id = undefined
      this.data.topic = []
      this.data.order_id = record.order_id
      this.data.course_id = record.cid
      // 根据课程id获取课程老师列表和教材列表
      getDictByCourse({ cid: this.data.course_id, material_ids: record.material_ids }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.materialDict = _.get(res, 'values.materialDict', [])
        }
      })
    },
    handleMaterialChange (value) {
      this.wareDict = []
      this.topicDict = []
      this.data.ware_id = undefined
      this.data.mat_id = value
      this.data.topic = []
      getDetailList({ mat_id: this.data.mat_id, size: 1000, type: 'TOPIC', order_by: 'pid ASC, detail_id DESC' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.topicDict = _.get(res, 'data', [])
          this.topicPidDict = _.get(res, 'values.topicDict', [])
        }
      })
      getDetailList({ mat_id: this.data.mat_id, size: 1000, type: 'WARE', order_by: 'title ASC' }).then(res => {
        if (_.get(res, 'code') === 200) {
          this.wareDict = _.get(res, 'data', [])
        }
      })
    },
    handleFileUpload (info, targetId) {
      if (info.file.status === 'removed') {
        this.data[targetId] = ''
      }
      const code = _.get(info.file, 'response.code')
      if (code && code !== 200) {
        this.$message.error(`${info.file.name} 上传失败`)
        return false
      }
      if (info.file.status === 'done') {
        const path = _.get(info.file, 'response.data.path')
        const fileUrl = _.get(info.file, 'response.data.url')
        this.data.kjpath = path
        this.$message.success(`${info.file.name} 图片上传成功`)
      } else if (info.file.status === 'error') {
        this.$message.error(`${info.file.name} 图片上传失败`)
      }
    },
    handleKjpahChange (info) {
      this.handleFileUpload(info, 'kjpath')
      if (info.fileList.length > 1) {
        info.fileList = info.fileList.splice(0, 1)
      }
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      )
    },
    // 弹窗保存按钮
    handleOk (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.confirmLoading = true
          const formData = Object.assign(this.data, values)
          formData['topicStr'] = formData.topic.join(',')
          yuYue(formData).then(res => {
            if (_.get(res, 'code') === 200) {
              const bookedNextTime = _.get(res, 'data.booked_next_time', '')
              this.confirmLoading = false
              this.$message.success('预约成功')
              this.$emit('finish',bookedNextTime)
            } else {
              this.confirmLoading = false
            }
          })
        }
      })
    },
    handleCancel () {
      this.$emit('hide')
    }
  },
  created () {
    // this.handelPre()
    this.modalTitel = this.planDetail.ctype + '预约'
    this.data.ctype = this.planDetail.ctype
    this.queryParam.ctname = this.ctname
  }
}
</script>
<style lang="less" scoped>
  .form-item {
    margin-bottom: 0px;
  }
</style>